var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M512,400.144c-170.667,69.189-341.333-69.189-512,0c0-96.096,0-192.193,0-288.288 c170.667-69.189,341.333,69.189,512,0C512,207.952,512,304.048,512,400.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4C653"
    },
    d: "M0,207.952c170.667-69.189,341.333,69.189,512,0v-96.096c-170.667,69.189-341.333-69.189-512,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87E87C"
    },
    d: "M0,400.144c170.667-69.189,341.333,69.189,512,0v-96.096c-170.667,69.189-341.333-69.189-512,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53BEF4"
    },
    d: "M253.694,229.141c1.195,4.093,1.814,8.184,2.259,12.276c0.423,4.093,0.619,8.184,0.623,12.276 c0.005,4.093-0.193,8.184-0.615,12.276c-0.444,4.093-1.066,8.184-2.267,12.276c-1.202-4.093-1.823-8.184-2.267-12.276 c-0.422-4.093-0.619-8.184-0.616-12.276c0.003-4.093,0.201-8.184,0.623-12.276C251.88,237.325,252.499,233.233,253.694,229.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53BEF4"
    },
    d: "M271.056,236.332c-2.049,3.739-4.505,7.069-7.084,10.278c-2.595,3.193-5.349,6.225-8.24,9.121 c-2.89,2.897-5.924,5.65-9.116,8.246c-3.207,2.58-6.541,5.034-10.284,7.078c2.045-3.743,4.498-7.076,7.078-10.284 c2.595-3.192,5.348-6.226,8.246-9.116c2.896-2.891,5.928-5.646,9.121-8.24C263.986,240.837,267.317,238.381,271.056,236.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53BEF4"
    },
    d: "M278.247,253.694c-4.093,1.195-8.184,1.814-12.276,2.259c-4.093,0.423-8.184,0.619-12.276,0.623 c-4.093,0.005-8.184-0.193-12.276-0.616c-4.093-0.444-8.184-1.066-12.276-2.267c4.093-1.202,8.184-1.823,12.276-2.267 c4.093-0.422,8.184-0.619,12.276-0.615c4.093,0.003,8.184,0.201,12.276,0.623C270.063,251.881,274.154,252.499,278.247,253.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53BEF4"
    },
    d: "M271.056,271.056c-3.739-2.049-7.069-4.505-10.278-7.084c-3.193-2.595-6.225-5.349-9.121-8.24 c-2.897-2.89-5.65-5.924-8.246-9.116c-2.58-3.207-5.034-6.541-7.078-10.284c3.743,2.043,7.076,4.498,10.284,7.078 c3.192,2.595,6.226,5.349,9.116,8.246c2.891,2.896,5.646,5.928,8.24,9.121C266.55,263.986,269.006,267.317,271.056,271.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53BEF4"
    },
    d: "M253.694,293.481c-21.939,0-39.787-17.849-39.787-39.787c0-21.939,17.849-39.787,39.787-39.787 c21.939,0,39.787,17.849,39.787,39.787C293.481,275.632,275.632,293.481,253.694,293.481z M253.694,219.672 c-18.759,0-34.021,15.262-34.021,34.021c0,18.76,15.262,34.021,34.021,34.021c18.76,0,34.021-15.262,34.021-34.021 C287.715,234.934,272.453,219.672,253.694,219.672z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.4b4ff5631ecbb6746e9bbd3635103174.svg";
export { ForwardRef as ReactComponent };